// Build-time version baked into the bundle via craco.config.js.
// Always displays even if /api/system/version is unreachable.
export const BUILD_VERSION =
  process.env.REACT_APP_BUILD_VERSION || "v1.58.0";
